module.exports = __webpack_public_path__ + "static/media/shenai.9ac967af.ogg";